var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LanguageSelect"},[_c('Dropdown',{attrs:{"options":_vm.dropdownOptions,"initialValue":_vm.value},on:{"input":function($event){_vm.value = $event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }